
// HeadlineModal.js
import React from "react";
import { Modal, BlockStack, Button, Text } from "@shopify/polaris";

function HeadlineModal({ open, onClose, headlines, onSelectHeadline, isGenerating }) {
  if (!headlines || headlines.length === 0) {
    return (
      <Modal
        open={open}
        onClose={onClose}
        title="AI-Generated Headlines"
        primaryAction={{
          content: 'Close',
          onAction: onClose,
        }}
      >
        <Modal.Section>
          <Text>No headlines available.</Text>
        </Modal.Section>
      </Modal>
    );
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="AI-Generated Headlines"
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose,
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="400">
          <Text variant="bodyMd" tone="subdued">
            Select a headline to replace your current article title. These headlines are optimized for engagement and SEO.
          </Text>
          
          <BlockStack gap="300">
            {headlines.map((headline, index) => (
              <div
                key={index}
                style={{
                  border: '1px solid #e1e3e5',
                  borderRadius: '8px',
                  padding: '16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  backgroundColor: '#fff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#005BD3';
                  e.currentTarget.style.backgroundColor = '#f6f6f7';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e1e3e5';
                  e.currentTarget.style.backgroundColor = '#fff';
                }}
              >
                <BlockStack gap="300">
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    {/* <div
                      style={{
                        minWidth: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        backgroundColor: '#005BD3',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: '600',
                        fontSize: '14px',
                      }}
                    >
                      {index + 1}
                    </div> */}
                    <div style={{ flex: 1 }}>
                      <Text variant="bodyMd" fontWeight="semibold">
                        {headline.title}
                      </Text>
                      {headline.reason && (
                        <Text variant="bodySm" tone="subdued" as="p">
                          {headline.reason}
                        </Text>
                      )}
                    </div>
                  </div>
                  <Button
                    onClick={() => onSelectHeadline(headline.title)}
                    variant="primary"
                    size="slim"
                  >
                    Use This Headline
                  </Button>
                </BlockStack>
              </div>
            ))}
          </BlockStack>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}

export default HeadlineModal;